import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-83ca6df4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "linkedin-step" }
const _hoisted_2 = { class: "left-side" }
const _hoisted_3 = { class: "right-side" }

import {computed, ref} from 'vue';
    import {useRouter} from 'vue-router';
    import LinkedinImportDialog from './linkedin-import-dialog/LinkedinImportDialog.vue';
    import Step from '@/profile-creation-wizard/common/ui/step/Step.vue';
    import LinkedinImportContent from './LinkedinImportContent.vue';
    import {useTranslation} from '@malt/vue3-use';
    import {useStore} from 'vuex';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'LinkedInImportStep',
  setup(__props) {

    const router = useRouter();
    const store = useStore();

    const {msg} = useTranslation();
    const isOpenedLinkedInDialog = ref(false);
    const funnelMode = store.state.funnelMode;
    const isFunnelStrategy = computed(() => store.state.isFunnelStrategy);

    function handleOpenLinkedInDialog() {
        isOpenedLinkedInDialog.value = true;
    }

    function handleCloseLinkedInDialog() {
        isOpenedLinkedInDialog.value = false;
    }

    function goNext(): void {
        router.push({name: router.currentRoute.value.meta.nextStep});
    }

    const baseKey = msg(`profile.creation.completion.wizard.v2.linkedin.${funnelMode.toLowerCase()}`);
    const title = msg(`${baseKey}.title`);

    const contentProps = {
        description: msg(`${baseKey}.description`),
        howToProceed: msg(`${baseKey}.howtoproceed`),
    };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Step, {
    "full-screen": "",
    "show-stepper": true,
    "is-skip-enabled": true,
    "show-skip-step": !isFunnelStrategy.value,
    "show-buttons": false,
    onGoToNext: goNext
  }, {
    "step-content": _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h1", {
            class: _normalizeClass(['linkedin-step__header', {'linkedin-step__header--strategy': isFunnelStrategy.value}])
          }, _toDisplayString(_unref(title)), 3)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(LinkedinImportContent, _mergeProps(contentProps, {
            onSelectedImportFromLinkedin: handleOpenLinkedInDialog,
            onSelectedAddManually: _cache[0] || (_cache[0] = ($event: any) => (goNext()))
          }), null, 16)
        ])
      ]),
      _createVNode(LinkedinImportDialog, {
        "is-opened": isOpenedLinkedInDialog.value,
        "onLinkedinDialog:cancel": handleCloseLinkedInDialog,
        "onLinkedinDialog:confirm": handleCloseLinkedInDialog
      }, null, 8, ["is-opened"])
    ]),
    _: 1
  }, 8, ["show-skip-step"]))
}
}

})